const COOKIE_KEY = 'only_fresh';
const MAX_AGE = 365 * 24 * 60 * 60; // 1 год

export function readOnlyFreshCookie(): boolean {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_KEY}=([^;]+)`));
    if (!match) return true; // по умолчанию «только свежие»
    return match[1] === '1';
}

export function writeOnlyFreshCookie(value: boolean) {
    document.cookie = `${COOKIE_KEY}=${value ? '1' : '0'}; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
}
